<template>
  <div class="project">
    <advertising-figure />
    <div class="inner-page-nav">
      <inner-page-nav />
    </div>
    <div class="inner-page-content">
      <public-title :title="title">
        <span class="sub">Project Visit</span>
      </public-title>

      <div class="divider">
        <h2 class="tit">项目名称: {{ this.$route.params.pv.name }}</h2>
        <span class="time"
          >发布日期:
          {{ simpleDateFormat(this.$route.params.pv.create_time) }}</span
        >
      </div>

      <div class="pro-detail">
        <div class="detail-info">
          <!-- <h2 class="tit">这是一个很厉害的项目</h2> -->
          <div class="article-wrap">
            <!-- <div class="article introduce">
                            <h3 class="sub-tit">项目介绍:</h3>
                            <p class="info">
                               {{this.$route.params.pv.content}}
                            </p>
                        </div> -->
            <div class="article details">
              <h3 class="sub-tit">项目详情:</h3>
              <RichHtml :content="$route.params.pv.detil"></RichHtml>
            </div>

            <!-- <div class="article img-wrap">
                            <img src="@assets/img/d1.jpg" alt="">
                            <img src="@assets/img/d2.jpg" alt="">
                            <img src="@assets/img/d3.jpg" alt="">
                            <img src="@assets/img/d3.jpg" alt="">
                            <img src="@assets/img/d2.jpg" alt="">
                            <img src="@assets/img/d1.jpg" alt="">
                        </div>

                        <div class="article introduce">
                            <h3 class="sub-tit">项目解读:</h3>
                            <p class="info">
                                这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目
                            </p>
                        </div>
                        <div class="article details">
                            <h3 class="sub-tit">项目特色:</h3>
                            <p class="info">
                                这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目
                            </p>
                        </div>

                         <div class="article img-wrap">
                            <img src="@assets/img/d1.jpg" alt="">
                            <img src="@assets/img/d2.jpg" alt="">
                            <img src="@assets/img/d3.jpg" alt="">
                        </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import AdvertisingFigure from "@components/advertising"
  import InnerPageNav from "@components/tool-nav"
  import publicTitle from "@components/title"
  import RichHtml from "@/components/RichHtml"

  export default {
    name: "ProjectVisitPage",
    components: {
      AdvertisingFigure,
      InnerPageNav,
      publicTitle,
      RichHtml
    },

    data() {
      return {
        title: "项目参观",
      }
    },

    methods: {},
  }
</script>

<style lang="scss" scoped>
  @import "@assets/scss/innerpagenav.scss";

  .inner-page-nav {
    position: relative;
    width: 1200px;
    height: 60px;
    padding: 0 15px;
    margin: 0 auto;
  }

  .inner-page-content {
    margin: 60px 0;
  }

  .divider {
    @include flex-between;
    width: 1200px;
    height: 50px;
    line-height: 50px;
    padding: 0 15px;
    margin: 30px auto 60px;
    border-bottom: 1px solid #eee;

    .tit {
      position: relative;
      font-size: 18px;
      color: #666;

      &:after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 30px;
        height: 2px;
        background: $defaultColor;
      }
    }

    .time {
      font-size: 14px;
      color: #999;
    }
  }

  .pro-detail {
    width: 1200px;
    margin: 30px auto;

    .detail-info {
      position: relative;
      padding: 30px;
      margin-bottom: 30px;
      min-height: 180px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);

      .tit {
        position: relative;
        left: 50%;
        transform: translateX(-50%);
        display: inline-block;
        min-width: 180px;
        font-size: 20px;
        margin: 30px 0;
        color: $defaultColor;
        padding: 0 30px;
        text-align: center;

        &:before {
          content: "";
          position: absolute;
          top: 50%;
          left: -100px;
          width: 100px;
          height: 2px;
          background: linear-gradient(to right, transparent, #ccc);
        }

        &:after {
          content: "";
          position: absolute;
          top: 50%;
          right: -100px;
          width: 100px;
          height: 2px;
          background: linear-gradient(to left, transparent, #ccc);
        }
      }

      .article-wrap {
        .article {
          margin-top: 30px;
          padding-bottom: 15px;
          border-bottom: 1px solid #eee;

          .sub-tit {
            font-size: 16px;
            margin-bottom: 10px;
            color: $defaultColor;
          }

          .info {
            font-size: 14px;
            line-height: 30px;
            color: #666;
          }
        }

        .img-wrap {
          display: flex;
          flex-wrap: wrap;
          margin-right: -15px;
          border: none;

          img {
            flex: 1;
            margin-right: 15px;
            margin-top: 15px;
          }
        }
      }
    }
  }

  .chose {
    text-align: center;

    .chose-select {
      display: inline-block;
      margin-top: 15px;

      span {
        font-size: 14px;
        color: $defaultColor;
        padding: 0 15px;
      }
    }

    .sign-up {
      display: block;
      width: 120px;
      margin: 30px auto 0;
    }
  }
</style>
